class LuxuryContactSplit extends HTMLElement {
  connectedCallback() {
    this.setupCounter();
    this.setupTourCarousel();
  }

  disconnectedCallback() {
    if (this.textarea && this.onInput) {
      this.textarea.removeEventListener('input', this.onInput);
    }
    this.stopTourAutoplay();
    this.tourEl?.removeEventListener('mouseenter', this.pauseTour);
    this.tourEl?.removeEventListener('mouseleave', this.resumeTour);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  setupCounter() {
    this.textarea = this.querySelector('[data-lcx-project]');
    this.counter = this.querySelector('[data-lcx-counter]');

    if (this.textarea && this.counter) {
      this.max = Number(this.textarea.getAttribute('maxlength')) || 255;
      this.onInput = this.updateCounter.bind(this);
      this.textarea.addEventListener('input', this.onInput);
      this.updateCounter();
    }
  }

  updateCounter() {
    const remaining = this.max - this.textarea.value.length;
    this.counter.textContent = `${remaining} characters remaining`;
  }

  setupTourCarousel() {
    this.tourEl = this.querySelector('[data-lcx-tour]');
    if (!this.tourEl) return;

    this.slides = Array.from(this.tourEl.querySelectorAll('[data-lcx-slide]'));
    this.dotsWrap = this.tourEl.querySelector('[data-lcx-tour-dots]');
    this.tourIndex = 0;
    this.tourAutoplay = this.tourEl.dataset.autoplay === 'true';
    this.tourIntervalMs = Number(this.tourEl.dataset.interval || 5) * 1000;
    this.tourTimer = null;

    if (this.slides.length <= 1) return;

    this.pauseTour = () => this.stopTourAutoplay();
    this.resumeTour = () => this.startTourAutoplay();
    this.onVisibility = () => {
      if (document.hidden) this.stopTourAutoplay();
      else this.startTourAutoplay();
    };

    this.buildTourDots();
    this.tourEl.addEventListener('mouseenter', this.pauseTour);
    this.tourEl.addEventListener('mouseleave', this.resumeTour);
    document.addEventListener('visibilitychange', this.onVisibility);

    this.startTourAutoplay();
  }

  buildTourDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.replaceChildren();

    this.slides.forEach((_, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `lcx__tour-dot${i === 0 ? ' is-active' : ''}`;
      button.setAttribute('aria-label', `Go to image ${i + 1}`);
      button.addEventListener('click', () => this.goTour(i, true));
      this.dotsWrap.appendChild(button);
    });
  }

  goTour(index, userTriggered) {
    const next = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === next);
    });

    if (this.dotsWrap) {
      this.dotsWrap.querySelectorAll('.lcx__tour-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === next);
      });
    }

    this.tourIndex = next;
    if (userTriggered) this.startTourAutoplay();
  }

  startTourAutoplay() {
    this.stopTourAutoplay();
    if (!this.tourAutoplay || this.slides.length <= 1 || document.hidden) return;
    this.tourTimer = window.setInterval(() => this.goTour(this.tourIndex + 1), this.tourIntervalMs);
  }

  stopTourAutoplay() {
    if (!this.tourTimer) return;
    window.clearInterval(this.tourTimer);
    this.tourTimer = null;
  }
}

if (!customElements.get('luxury-contact-split')) {
  customElements.define('luxury-contact-split', LuxuryContactSplit);
}
